import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../components/modal/PropdocsModal';
import { DocumentTemplateModalComponentProps } from './DocumentTemplateModalContainer';

const CreateBlankDocumentModal = ({ isOpen, onClose, modalFilters }: DocumentTemplateModalComponentProps) => {
  return (
    <Modal
      show={isOpen}
      setShow={onClose}
      size="md"
      title={<FormattedMessage id="title.first-lease-template" defaultMessage="Create Blank Document" />}
    >
      <>{modalFilters || <div></div>}</>
    </Modal>
  );
};

export default CreateBlankDocumentModal;
